import * as React from 'react';

import MessageSearch from '../../../guideMessaging/components/MessageSearch';

export default function MessageSearchScreen() {
    return <MessageSearch />;
}
